import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import AdminsPage from './components/pages/admin/AdminsPage';
import ManageAdminsPage from './components/pages/admin/ManageAdminsPage';
import AnalyticsPage from './components/pages/AnalyticsPage';
import LoginPage from './components/pages/auth/LoginPage';
import NotFoundPage from './components/pages/NotFoundPage';
import NotificationPage from './components/pages/notification/NotificationPage';
import PaymentMethodsPage from './components/pages/payments/PaymentMethodsPage';
import ProfilePage from './components/pages/ProfilePage';
import AppliedPromotionsPage from './components/pages/promotions/AppliedPromotionsPage';
import ManagePromotionsPage from './components/pages/promotions/ManagePromotionsPage';
import PromotionsPage from './components/pages/promotions/PromotionsPage';
import RefundsPage from './components/pages/refunds/RefundsPage';
import SettingsPage from './components/pages/SettingsPage';
import SupportPage from './components/pages/SupportPage';
import TransactionBreakdownPage from './components/pages/transactions/TransactionBreakdownPage';
import TransactionsPage from './components/pages/transactions/TransactionsPage';
import TransferBreakdownPage from './components/pages/transactions/TransferBreakdownPage';
import TripsPage from './components/pages/trips/TripsPage';
import UserTripHistoryPage from './components/pages/trips/UserTripHistoryPage';
import ViewTripsDetails from './components/pages/trips/ViewTripsDetails';
import ManageUsers from './components/pages/users/ManageUsers';
import UsersPage from './components/pages/users/UsersPage';
import ManageVehicles from './components/pages/vehicles/ManageVehicles';
import VehiclesPage from './components/pages/vehicles/VehiclesPage';
import DashBoard from './components/templates/DashBoard';

function App() {
  const { pathname } = useLocation();
  const state = useSelector((state) => state);
  console.log('state', state);
  return (
    <div>
      <Toaster />
      <Routes>
        <Route path='/login' element={<LoginPage />} />
        <Route path='/' element={<DashBoard path={pathname} />}>
          <Route path='/trips' element={<TripsPage />} />
          <Route path='/trips/:id' element={<ViewTripsDetails />} />
          <Route path='/analytics' element={<AnalyticsPage />} />
          <Route path='/profile' element={<ProfilePage />} />
          <Route path='/support' element={<SupportPage />} />
          <Route path='/notifications' element={<NotificationPage />} />
          <Route path='/refunds' element={<RefundsPage />} />
          <Route path='/payment-methods' element={<PaymentMethodsPage />} />
          <Route path='/settings' element={<SettingsPage />} />
          <Route path='/transactions'>
            <Route index element={<TransactionsPage />} />
            <Route path=':id' element={<TransactionBreakdownPage />} />
            <Route path='transfer/:id' element={<TransferBreakdownPage />} />
          </Route>
          <Route path='/admins'>
            <Route index element={<AdminsPage />} />
            <Route path='create' element={<ManageAdminsPage />} />
          </Route>
          <Route path='/promotions'>
            <Route index element={<PromotionsPage />} />
            <Route path='create' element={<ManagePromotionsPage />} />
            <Route path='applied' element={<AppliedPromotionsPage />} />
          </Route>
          <Route path='/vehicles'>
            <Route index element={<VehiclesPage />} />
            <Route path='register' element={<ManageVehicles />} />
            <Route path='edit/:id' element={<ManageVehicles />} />
          </Route>
          <Route path='/users'>
            <Route index element={<UsersPage />} />
            <Route path='trip-history/:id' element={<UserTripHistoryPage />} />
            <Route path=':operation/:id' element={<ManageUsers />} />
          </Route>
        </Route>
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
